import React from 'react';
import './Clientes.css';

import logo1 from '../assets/clientes/logo1.png';
import logo2 from '../assets/clientes/logo2.png';
import logo3 from '../assets/clientes/logo3.png';
import logo4 from '../assets/clientes/logo4.png';

const logos = [logo1, logo2, logo3, logo4];
const repeatedLogos = [...Array(4)].flatMap(() => logos);

function Clientes() {
  return (
    <section className="clientes-section" id="clientes">
      <div className="dots-animation">
        <span></span><span></span><span></span>
      </div>
      <h2>Clientes que confiam na Lampo</h2>
      <div className="slider">
        <div className="slide-track">
          {repeatedLogos.map((logo, index) => (
            <div className="slide" key={index}>
              <img src={logo} alt={`Logo cliente ${index + 1}`} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Clientes;
